
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum
} = require('@prisma/client/runtime/index-browser')


const Prisma = {}

exports.Prisma = Prisma

/**
 * Prisma Client JS version: 4.11.0
 * Query Engine version: 8fde8fef4033376662cad983758335009d522acb
 */
Prisma.prismaVersion = {
  client: "4.11.0",
  engine: "8fde8fef4033376662cad983758335009d522acb"
}

Prisma.PrismaClientKnownRequestError = () => {
  throw new Error(`PrismaClientKnownRequestError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  throw new Error(`PrismaClientUnknownRequestError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientRustPanicError = () => {
  throw new Error(`PrismaClientRustPanicError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientInitializationError = () => {
  throw new Error(`PrismaClientInitializationError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientValidationError = () => {
  throw new Error(`PrismaClientValidationError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.NotFoundError = () => {
  throw new Error(`NotFoundError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  throw new Error(`sqltag is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.empty = () => {
  throw new Error(`empty is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.join = () => {
  throw new Error(`join is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.raw = () => {
  throw new Error(`raw is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.validator = () => (val) => val


/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}

/**
 * Enums
 */
// Based on
// https://github.com/microsoft/TypeScript/issues/3192#issuecomment-261720275
function makeEnum(x) { return x; }

exports.Prisma.AccountScalarFieldEnum = makeEnum({
  id: 'id',
  userId: 'userId',
  type: 'type',
  provider: 'provider',
  providerAccountId: 'providerAccountId',
  refresh_token: 'refresh_token',
  access_token: 'access_token',
  expires_at: 'expires_at',
  token_type: 'token_type',
  scope: 'scope',
  id_token: 'id_token',
  session_state: 'session_state'
});

exports.Prisma.AppointmentScalarFieldEnum = makeEnum({
  id: 'id',
  appointmentDate: 'appointmentDate',
  createdAt: 'createdAt',
  note: 'note',
  isNewPatient: 'isNewPatient',
  patientId: 'patientId',
  operatoryId: 'operatoryId',
  providerId: 'providerId',
  userId: 'userId',
  reasonId: 'reasonId'
});

exports.Prisma.AvailabilityScalarFieldEnum = makeEnum({
  id: 'id',
  userId: 'userId',
  eventTypeId: 'eventTypeId',
  days: 'days',
  date: 'date',
  startTime: 'startTime',
  endTime: 'endTime',
  scheduleId: 'scheduleId'
});

exports.Prisma.AvailableTimeScalarFieldEnum = makeEnum({
  id: 'id',
  startTime: 'startTime',
  endTime: 'endTime',
  providerId: 'providerId',
  operatoryId: 'operatoryId',
  duration: 'duration',
  userId: 'userId'
});

exports.Prisma.EventTypeScalarFieldEnum = makeEnum({
  id: 'id',
  title: 'title',
  slug: 'slug',
  description: 'description',
  locations: 'locations',
  length: 'length',
  hidden: 'hidden',
  userId: 'userId',
  eventName: 'eventName',
  timeZone: 'timeZone',
  periodCountCalendarDays: 'periodCountCalendarDays',
  periodDays: 'periodDays',
  periodEndDate: 'periodEndDate',
  periodStartDate: 'periodStartDate',
  requiresConfirmation: 'requiresConfirmation',
  minimumBookingNotice: 'minimumBookingNotice',
  currency: 'currency',
  price: 'price',
  schedulingType: 'schedulingType',
  teamId: 'teamId',
  disableGuests: 'disableGuests',
  position: 'position',
  periodType: 'periodType',
  slotInterval: 'slotInterval',
  metadata: 'metadata',
  afterEventBuffer: 'afterEventBuffer',
  beforeEventBuffer: 'beforeEventBuffer',
  hideCalendarNotes: 'hideCalendarNotes',
  successRedirectUrl: 'successRedirectUrl',
  seatsPerTimeSlot: 'seatsPerTimeSlot',
  recurringEvent: 'recurringEvent',
  scheduleId: 'scheduleId',
  bookingLimits: 'bookingLimits',
  seatsShowAttendees: 'seatsShowAttendees',
  bookingFields: 'bookingFields'
});

exports.Prisma.JsonNullValueFilter = makeEnum({
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
});

exports.Prisma.NullableJsonNullValueInput = makeEnum({
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull
});

exports.Prisma.OnlineAppointmentScalarFieldEnum = makeEnum({
  id: 'id',
  apptNumber: 'apptNumber',
  status: 'status',
  isNewPatient: 'isNewPatient',
  scheduleDate: 'scheduleDate',
  note: 'note',
  startTime: 'startTime',
  endTime: 'endTime',
  providerId: 'providerId',
  operatoryId: 'operatoryId',
  patientId: 'patientId',
  procDescription: 'procDescription',
  userId: 'userId',
  updatedAt: 'updatedAt'
});

exports.Prisma.OnlinePatientScalarFieldEnum = makeEnum({
  id: 'id',
  firstName: 'firstName',
  lastName: 'lastName',
  birthdate: 'birthdate',
  email: 'email',
  patientId: 'patientId',
  homePhone: 'homePhone',
  workPhone: 'workPhone',
  cellPhone: 'cellPhone',
  ssn: 'ssn',
  address: 'address',
  address2: 'address2',
  city: 'city',
  state: 'state',
  zip: 'zip',
  guarantor: 'guarantor',
  preferContactMethod: 'preferContactMethod',
  userId: 'userId'
});

exports.Prisma.OnlineScheduleScalarFieldEnum = makeEnum({
  id: 'id',
  scheduleNum: 'scheduleNum',
  type: 'type',
  startTime: 'startTime',
  endTime: 'endTime',
  providerId: 'providerId',
  operatoryIds: 'operatoryIds',
  userId: 'userId',
  blockoutType: 'blockoutType'
});

exports.Prisma.OperatoryScalarFieldEnum = makeEnum({
  id: 'id',
  name: 'name',
  opNum: 'opNum',
  userId: 'userId'
});

exports.Prisma.PatientScalarFieldEnum = makeEnum({
  id: 'id',
  firstName: 'firstName',
  lastName: 'lastName',
  birthday: 'birthday',
  email: 'email',
  phoneNumber: 'phoneNumber',
  userId: 'userId'
});

exports.Prisma.ProcedureBlockoutScalarFieldEnum = makeEnum({
  id: 'id',
  code: 'code',
  type: 'type',
  blockout: 'blockout',
  userId: 'userId'
});

exports.Prisma.ProcedureTimeScalarFieldEnum = makeEnum({
  id: 'id',
  procName: 'procName',
  providers: 'providers',
  codes: 'codes',
  count: 'count',
  length: 'length',
  userId: 'userId',
  toothNums: 'toothNums',
  patientMinAge: 'patientMinAge',
  patientMaxAge: 'patientMaxAge',
  combineProcs: 'combineProcs'
});

exports.Prisma.ProviderScalarFieldEnum = makeEnum({
  id: 'id',
  name: 'name',
  speciality: 'speciality',
  provNum: 'provNum',
  userId: 'userId',
  threshold: 'threshold',
  scheduleId: 'scheduleId',
  avatar: 'avatar',
  availableDays: 'availableDays',
  isActive: 'isActive'
});

exports.Prisma.QueryMode = makeEnum({
  default: 'default',
  insensitive: 'insensitive'
});

exports.Prisma.ReasonForVisitScalarFieldEnum = makeEnum({
  id: 'id',
  name: 'name',
  description: 'description',
  patientStatus: 'patientStatus',
  duration: 'duration',
  userId: 'userId',
  cost: 'cost',
  lowerAgeLimit: 'lowerAgeLimit',
  excludeBlockouts: 'excludeBlockouts',
  includeBlockouts: 'includeBlockouts',
  visitCategoryId: 'visitCategoryId',
  isInternal: 'isInternal',
  minAge: 'minAge',
  maxAge: 'maxAge'
});

exports.Prisma.ScheduleScalarFieldEnum = makeEnum({
  id: 'id',
  userId: 'userId',
  name: 'name',
  timeZone: 'timeZone'
});

exports.Prisma.SessionScalarFieldEnum = makeEnum({
  id: 'id',
  sessionToken: 'sessionToken',
  userId: 'userId',
  expires: 'expires'
});

exports.Prisma.SortOrder = makeEnum({
  asc: 'asc',
  desc: 'desc'
});

exports.Prisma.TeamScalarFieldEnum = makeEnum({
  id: 'id',
  name: 'name',
  slug: 'slug',
  bio: 'bio',
  hideBranding: 'hideBranding',
  logo: 'logo',
  createdAt: 'createdAt',
  metadata: 'metadata',
  hideBookATeamMember: 'hideBookATeamMember',
  brandColor: 'brandColor',
  darkBrandColor: 'darkBrandColor',
  theme: 'theme'
});

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.UserScalarFieldEnum = makeEnum({
  id: 'id',
  username: 'username',
  name: 'name',
  email: 'email',
  password: 'password',
  bio: 'bio',
  avatar: 'avatar',
  timeZone: 'timeZone',
  weekStart: 'weekStart',
  startTime: 'startTime',
  endTime: 'endTime',
  createdDate: 'createdDate',
  bufferTime: 'bufferTime',
  emailVerified: 'emailVerified',
  hideBranding: 'hideBranding',
  theme: 'theme',
  completedOnboarding: 'completedOnboarding',
  twoFactorEnabled: 'twoFactorEnabled',
  twoFactorSecret: 'twoFactorSecret',
  locale: 'locale',
  brandColor: 'brandColor',
  identityProvider: 'identityProvider',
  identityProviderId: 'identityProviderId',
  invitedTo: 'invitedTo',
  metadata: 'metadata',
  away: 'away',
  verified: 'verified',
  timeFormat: 'timeFormat',
  darkBrandColor: 'darkBrandColor',
  trialEndsAt: 'trialEndsAt',
  defaultScheduleId: 'defaultScheduleId',
  allowDynamicBooking: 'allowDynamicBooking',
  role: 'role',
  disableImpersonation: 'disableImpersonation',
  scoreOptions: 'scoreOptions',
  address1: 'address1',
  address2: 'address2',
  logo: 'logo',
  credential: 'credential',
  paymentCredential: 'paymentCredential',
  excludeDates: 'excludeDates',
  appointmentSyncTime: 'appointmentSyncTime',
  patientSyncTime: 'patientSyncTime',
  overrideBrokenAppointment: 'overrideBrokenAppointment'
});

exports.Prisma.VerificationTokenScalarFieldEnum = makeEnum({
  id: 'id',
  identifier: 'identifier',
  token: 'token',
  expires: 'expires',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
});

exports.Prisma.VisitCategoryScalarFieldEnum = makeEnum({
  id: 'id',
  name: 'name',
  userId: 'userId'
});

exports.Prisma.WorkflowReminderScalarFieldEnum = makeEnum({
  id: 'id',
  method: 'method',
  scheduledDate: 'scheduledDate',
  referenceId: 'referenceId',
  scheduled: 'scheduled',
  workflowStepId: 'workflowStepId',
  cancelled: 'cancelled'
});

exports.Prisma.WorkflowScalarFieldEnum = makeEnum({
  id: 'id',
  name: 'name',
  userId: 'userId',
  trigger: 'trigger',
  time: 'time',
  timeUnit: 'timeUnit',
  teamId: 'teamId'
});

exports.Prisma.WorkflowStepScalarFieldEnum = makeEnum({
  id: 'id',
  stepNumber: 'stepNumber',
  action: 'action',
  workflowId: 'workflowId',
  sendTo: 'sendTo',
  reminderBody: 'reminderBody',
  emailSubject: 'emailSubject',
  template: 'template',
  numberRequired: 'numberRequired',
  sender: 'sender',
  numberVerificationPending: 'numberVerificationPending'
});

exports.Prisma.WorkflowsOnEventTypesScalarFieldEnum = makeEnum({
  id: 'id',
  workflowId: 'workflowId',
  eventTypeId: 'eventTypeId'
});
exports.IdentityProvider = makeEnum({
  CAL: 'CAL',
  GOOGLE: 'GOOGLE',
  SAML: 'SAML'
});

exports.PatientStatus = makeEnum({
  NEW: 'NEW',
  RETURNING: 'RETURNING'
});

exports.PeriodType = makeEnum({
  UNLIMITED: 'UNLIMITED',
  ROLLING: 'ROLLING',
  RANGE: 'RANGE'
});

exports.ProcedureType = makeEnum({
  SEDATION_MAJOR: 'SEDATION_MAJOR',
  MAJOR: 'MAJOR',
  MINOR: 'MINOR',
  NON_PROD: 'NON_PROD',
  HYGIENE: 'HYGIENE'
});

exports.SchedulingType = makeEnum({
  ROUND_ROBIN: 'ROUND_ROBIN',
  COLLECTIVE: 'COLLECTIVE'
});

exports.TimeUnit = makeEnum({
  DAY: 'DAY',
  HOUR: 'HOUR',
  MINUTE: 'MINUTE'
});

exports.UserPermissionRole = makeEnum({
  USER: 'USER',
  ADMIN: 'ADMIN'
});

exports.WorkflowActions = makeEnum({
  EMAIL_HOST: 'EMAIL_HOST',
  EMAIL_ATTENDEE: 'EMAIL_ATTENDEE',
  SMS_ATTENDEE: 'SMS_ATTENDEE',
  SMS_NUMBER: 'SMS_NUMBER',
  EMAIL_ADDRESS: 'EMAIL_ADDRESS'
});

exports.WorkflowMethods = makeEnum({
  EMAIL: 'EMAIL',
  SMS: 'SMS'
});

exports.WorkflowTemplates = makeEnum({
  REMINDER: 'REMINDER',
  CUSTOM: 'CUSTOM'
});

exports.WorkflowTriggerEvents = makeEnum({
  BEFORE_EVENT: 'BEFORE_EVENT',
  EVENT_CANCELLED: 'EVENT_CANCELLED',
  NEW_EVENT: 'NEW_EVENT',
  RESCHEDULE_EVENT: 'RESCHEDULE_EVENT',
  AFTER_EVENT: 'AFTER_EVENT'
});

exports.Prisma.ModelName = makeEnum({
  User: 'User',
  Account: 'Account',
  Session: 'Session',
  VerificationToken: 'VerificationToken',
  EventType: 'EventType',
  Provider: 'Provider',
  Operatory: 'Operatory',
  VisitCategory: 'VisitCategory',
  ReasonForVisit: 'ReasonForVisit',
  Patient: 'Patient',
  Appointment: 'Appointment',
  Team: 'Team',
  Schedule: 'Schedule',
  Availability: 'Availability',
  WorkflowStep: 'WorkflowStep',
  Workflow: 'Workflow',
  WorkflowsOnEventTypes: 'WorkflowsOnEventTypes',
  WorkflowReminder: 'WorkflowReminder',
  OnlinePatient: 'OnlinePatient',
  OnlineSchedule: 'OnlineSchedule',
  OnlineAppointment: 'OnlineAppointment',
  AvailableTime: 'AvailableTime',
  ProcedureTime: 'ProcedureTime',
  ProcedureBlockout: 'ProcedureBlockout'
});

/**
 * Create the Client
 */
class PrismaClient {
  constructor() {
    throw new Error(
      `PrismaClient is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
    )
  }
}
exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
